import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Row } from 'react-bootstrap';
import { HappContainer } from 'happ-components/HappStyledComponents/HappContainer/HappContainer';
import LoaderView from 'happ-components/Loader/LoaderView';
import { useDispatch } from 'react-redux';

import { isLogin } from 'happ-redux/happ-actions/auth/authActions';

const SsoSamlLogin = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const hasActiveSsoLogin = useRef(false);

    useEffect(() => {
        const activeSsoLogin = () => {
            const { search } = location;
            const token = search.split('t=', 2)[1];
            const error = search.split('e=', 2)[1];
            if (error && error === 'user-not-found') {
                localStorage.clear();
                navigate('/sso/saml/user-not-found');
            } else {
                if (!token) {
                    localStorage.clear();
                    navigate('/login');
                } else {
                    const currentToken = localStorage.getItem("token");
                    if (currentToken) {
                        localStorage.clear();
                        localStorage.setItem('token', token);
                    }
                    localStorage.setItem('token', token);
                    navigate('/');
                    dispatch(isLogin(navigate));
                }
            }
        }
        if (
            !hasActiveSsoLogin.current &&
            location.pathname === '/sso/saml/callback' &&
            location.search !== ''
        ) {
            hasActiveSsoLogin.current = true;
            activeSsoLogin();
        }
    }, [location]);

    return (
        <Row className="mt-content ">
            <HappContainer>
                <>
                    <div className='text-center mt-5 mb-3'>
                        <LoaderView
                            animation="border"
                        />
                        <p>Redireccionando a Happ...</p>
                    </div>
                </>
            </HappContainer>
        </Row>
    );
}

export default SsoSamlLogin;